import { render } from "./HelpRequestDetailBox.vue?vue&type=template&id=59cf8fe6"
import script from "./HelpRequestDetailBox.vue?vue&type=script&lang=js"
export * from "./HelpRequestDetailBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__